<template>
    <div class="row">
		<div class="col-12">
			<div class="CustomBlockWidth inMiddle-area whitebox p-3 mt-4">
				<div class="headAID d-flex align-items-center justify-content-between">
					<p>{{$t('detch_detachaccount')}} <strong><span class="green">{{$t('detch_fourfive')}}</span> </strong></p>
					<p>{{$t('detch_pamMaster')}} <strong><span class="green">{{$t('detch_todd')}}</span> </strong></p>
				</div>
				<div class="inMiddle-area table-responsive mt-3 lightGreen p-2">
					<table class="table customize">
						<thead>
							<tr>
								<th>{{$t('detch_balance')}}</th>
								<th>{{$t('detch_equity')}}</th> 
								<th>{{$t('detch_freeMargin')}}</th> 
								<th>{{$t('detch_MarginUSed')}}</th> 
								<th>{{$t('detch_pnl')}}</th> 
							</tr>
						</thead>
							<tr>
								<td>{{$t('detch_two')}}</td>
								<td>{{$t('detch_eight')}}</td>
								<td>{{$t('detch_twelve')}}</td>
								<td>{{$t('detch_three')}}</td>
								<td>{{$t('detch_twofive')}}</td>
							</tr>
						<tbody>
						</tbody>
					</table>
				</div>
				<div class="noteList mt-4">
					<p>{{$t('detch_takenote')}</p>
					<ul class="listing circle my-3"> 
						<li>{{$t('detch_openPosition')}</li>
						<li>{{$t('detch_finalPnl')}</li>
						<li>{{$t('detch_afterOpen')}</li>
					</ul>
					<label class="fancy_radiochk_btn">{{$t('detch_terms')}
					  <input type="checkbox" checked="checked">
					  <span class="checkmark"></span>
					</label>
					<div class="confirmButton text-center mt-4">
						<a href="#" class="prism_btn btn_sm">{{$t('detch_confirm')}</a>
					</div>
				</div>
				
				<!--Success Message-->

				<!-- <div class="congrats text-center pt-3">
					<img class="mb-2" src="../../../../static/fxView/images/congrats.png" alt="Icon">
					<p>Your MT4 account ID <strong class="green">454579</strong> has been successfully detached from <strong class="green">Todd Anderson</strong></p>
				</div> -->
			</div>
		</div>
    </div>
</template>
<script>
    export default {
        name: 'Detach-Account',
        data() {
            return {
				
            }
        },
       
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/manageAccounts/detach_account.vue